import { TemplateEditorProps as _TemplateEditorProps } from "./TemplateEditor";

export { default } from "./TemplateEditor";
export type TemplateEditorProps = _TemplateEditorProps;
